export const skippableStagesTransformer = (data = []) => {
  const previousSkippableStages = {}
  let prevLabels = []
  const transformedData = data.map(item => {
    previousSkippableStages[item?.stageId] = prevLabels?.join(",")
    prevLabels.push(item?.stageName)
    return {
      ...item,
      id: item?.stageId,
      value: item?.stageId?.toString(),
      label: item?.stageName,
    }
  })

  return { previousSkippableStages, data: transformedData }
}
